import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Divider } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { SectionText } from '@fortress-technology-solutions/fortress-component-library/Molecules_Portal';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';

const Eligibility = ({ fields, ReactHookFormProps, onSubmit }) => {
  // Filter out any non-DOM props from fields if needed
  const sanitizedFields = fields.map((field) => {
    const { isAffordaPortalSpecific, ...rest } = field;
    return rest;
  });

  return (
    <>
      <SectionText
        title={<FormattedMessage id="afforda.eligibility.title" />}
        description=""
      />
      <Divider sx={{ marginBottom: 2 }} />
      <Form
        containerSX={{ textAlign: 'left' }}
        fields={sanitizedFields}
        ReactHookFormProps={ReactHookFormProps}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default Eligibility;
